module.exports = "<div ng-controller=\"modalController\">\r\n    <img ng-src=\"{{ entry.values.icon_url }}\"\r\n         width=\"45\"\r\n         height=\"45\"\r\n         ng-click=\"openModalImage(entry.values.icon_url, 'thumbnail')\">\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./templates/modalTemplate.html
// module id = 190
// module chunks = 0